<template>
  <div>
    <div v-if="['PF Playtest', 'PFRPG2', 'Embers RPG'].includes(ruleset)">
      <div class="row">
        <div class="col">
          <under-input v-model="item.name">Name</under-input>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <under-select v-model="item.type" :options="actionTypes">Type</under-select>
        </div>
        <div class="col-2">
          <under-input v-model="item.range">
            <span v-if="item.type === 'Melee'">Reach</span>
            <span v-else>Range</span>
          </under-input>
        </div>
        <div class="col-3 text-center">
          <proficiency v-model="item.attack.proficiency">Proficiency</proficiency>
        </div>
        <div class="col-3 text-center">
          <pf-actions v-model="item.actions">Actions</pf-actions>
        </div>
      </div>
    </div>

    <div v-else>
      <div class="row">
        <div class="col">
          <under-input v-model="item.name">Name</under-input>
        </div>
        <div class="col-3">
          <under-select v-model="item.type" :options="actionTypes">Type</under-select>
        </div>
        <div class="col-3">
          <under-input v-model="item.range">
            <span v-if="item.type === 'Melee'">Reach</span>
            <span v-else>Range</span>
          </under-input>
        </div>
        <div class="col-2 text-center" v-if="!['Savage Embers', 'Savage Worlds'].includes(ruleset)">
          <under-checkbox v-model="item.proficient">Prof</under-checkbox>
        </div>
      </div>
    </div>

    <h6>Attack</h6>
    <div class="attack" v-if="['Savage Embers', 'Savage Worlds'].includes(ruleset)">
      <div class="row">
        <div class="col">
          <under-select v-model="item.attack.skill" :options="skillOptions">Skill</under-select>
        </div>
        <div class="col-3">
          <under-input v-model.Number="item.attack.misc" type="number">Misc</under-input>
        </div>
      </div>
    </div>
    <div class="attack" v-else>
      <div class="row">
        <div class="col-3">
          <under-text class="text-center">
            <span slot="underline">
              <a>{{ attackBonus }}</a>
            </span>
            Bonus
          </under-text>
        </div>
        <div class="col">
          <under-select v-model="item.attack.attribute" :options="attributeOptions">Ability Score</under-select>
        </div>
        <div class="col-2">
          <under-input v-model.Number="item.attack.misc" type="number">Misc</under-input>
        </div>
        <div class="col-2">
          <under-input v-model.Number="item.attack.magic" type="number">Magic</under-input>
        </div>
      </div>
    </div>

    <h6>Damage</h6>
    <div class="damage" v-if="['Savage Embers', 'Savage Worlds'].includes(ruleset)">
      <div class="row">
        <div class="col-3">
          <under-input v-model="item.damage.dice">Dice</under-input>
        </div>
        <div class="col">
          <under-select v-model="item.damage.attribute" :options="attributeOptions">Ability Score</under-select>
        </div>
        <div class="col-2">
          <under-input v-model.Number="item.damage.misc" type="number">Misc</under-input>
        </div>
        <div class="col">
          <under-input v-model="item.damage.type">Type</under-input>
        </div>
      </div>
    </div>
    <div class="damage" v-else>
      <div class="row">
        <div class="col-3">
          <under-text class="text-center">
            <span slot="underline">
              <a>{{ damageBonus }}</a>
            </span>
            Bonus
          </under-text>
        </div>
        <div class="col">
          <under-select v-model="item.damage.attribute" :options="attributeOptions">Ability Score</under-select>
        </div>
        <div class="col-2">
          <under-input v-model.Number="item.damage.misc" type="number">Misc</under-input>
        </div>
        <div class="col-2">
          <under-input v-model.Number="item.damage.magic" type="number">Magic</under-input>
        </div>
      </div>
      <div class="row">
        <div class="col-3">
          <under-input v-model="item.damage.dice">Dice</under-input>
        </div>
        <div class="col">
          <under-input v-model="item.damage.type">Type</under-input>
        </div>
        <div class="col-4">
          <under-input v-model="item.damage.critical">Critical</under-input>
        </div>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col">
        <under-input v-model="item.summary" maxlength="255">Summary</under-input>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <under-text-area-md v-model="item.description" rows="4">Description</under-text-area-md>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Proficiency from "../shared/_Proficiency.vue";
import PfActions from "../shared/_PfActions.vue";
import UnderCheckbox from "../shared/_UnderCheckbox.vue";
import UnderInput from "../shared/_UnderInput.vue";
import UnderSelect from "../shared/_UnderSelect.vue";
import UnderText from "../shared/_UnderText.vue";
import UnderTextAreaMd from "../shared/_UnderTextAreaMd.vue";

export default {
  name: "sheet-actions-default",
  components: {
    Proficiency,
    PfActions,
    UnderCheckbox,
    UnderInput,
    UnderSelect,
    UnderText,
    UnderTextAreaMd,
  },
  props: ["item", "attackBonus", "damageBonus"],
  computed: mapState({
    ruleset: (state) => state.characters.current.ruleset,
    skills: (state) => state.characters.current.skills,
    actionTypes() {
      let options = [];
      this.$rpgv.actionTypes.forEach((element) => {
        options.push({ text: element, value: element });
      });
      return options;
    },
    attributeOptions() {
      let options = this.$rulesets[this.ruleset].attributeOptions();
      options.unshift({ text: "", value: "" });
      return options;
    },
    skillOptions() {
      let core = this.skills.map((x) => x.name);
      let options = [];
      core.forEach(function (element) {
        options.push({ text: element, value: element.toLowerCase() });
      });
      options.unshift({ text: "", value: "" });

      return options;
    },
  }),
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/_global";

.attack {
  padding: 0.25em;
}
.damage {
  padding: 0.25em;
}
h6 {
  margin-bottom: 0;
  margin-top: 0.5em;
}
</style>
